import { Component, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { map, Subscription } from 'rxjs';
import { RentalObjectDocumentService } from '../../service/data/rental-object-document.service';
import { RentalObject } from '../../model/rental-object';
import { RentalObjectDocument } from '../../model/rental-object-document';
import { RentalObjectDocumentType, RentalObjectDocumentTypeToString } from '../../model/const/documentEnums';
import { SelectionItem } from '../../../core/component/select/select.component';
import { DwellingService } from '../../service/data/dwelling.service';
import { BrokerInformation } from '../../model/broker-information';
import { LocalDate } from '../../../core/model/local-date';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { MessageService } from '../../../core/service/message.service';
import { UserAccountService } from '../../../common/service/user-account.service';

@Component({
    selector: 'app-broker-information-form',
    templateUrl: './broker-information-form-component.html',
    styleUrls: ['./broker-information-form-component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BrokerInformationFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: DwellingService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _renderer: Renderer2,
    private _nativeWindow: NativeWindowService,
    private _messageService: MessageService,
    private _accountService: UserAccountService
  ) {}

  private _subscription: Subscription = new Subscription();
  dataContext: RentalObject;
  form: FormGroup;

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  typeOfDateSelection: { name: string; value: string }[];
  ngOnInit() {
    const today = new Date();
    this.form = this._fb.group({
      calculationDate: this._fcf.createMandatory(
        'RENTAL_OBJECT.BROKER_INFORMATION_DATE',
        LocalDate.today(),
        'RENTAL_OBJECT.BROKER_INFORMATION_DATE_DESCRIPTION'
      ),
      rentalObjectId: this._fcf.createHidden(this.dataContext.id),
      typeOfCalculationDate: this._fcf.create('COOPERATIVE_HOUSING.SHOW_INFORMATION_REGARDING', this.defaultCalculationDateType),
      fileName: this._fcf.createHidden('Maklarbild.pdf'),
    });

    this.typeOfDateSelection = [{ name: 'COOPERATIVE_HOUSING.ACQUISITION_DATE', value: "acquisitiondate" }];
    this.typeOfDateSelection.push({ name: 'COOPERATIVE_HOUSING.ACCESS_DATE', value: "accessdate" });
  }

  private get defaultCalculationDateType(): string {
    return this._accountService.profileSettings?.brfLeaseAgreementDateType === 1 ? 'accessdate' : 'acquisitiondate';
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.dataContext.formOfLease == 1) {
        this._subscription.add(
          this._dataService
            .printBrokerInformation(Object.assign(new BrokerInformation(), this.form.value))
            .pipe(
              map(res => {
                if (res) {
                  this._nativeWindow.save(res);
                }
              })
            )
            .subscribe(res => this._actionService.complete(res))
        );
      } else {
        this._messageService.showError('RENTAL_OBJECT.BROKER_INFORMATION_FORM_OF_LEASE_MESSAGE');
        this._actionService.close();
      }
    }
  }
}
